const GameModelEvent = {};
export default GameModelEvent;

GameModelEvent.PUZZLE = "GameModelEvent.PUZZLE";
GameModelEvent.ELAPSED_TIME = "GameModelEvent.ELAPSED_TIME";
